import moment from "moment";

export const formatDate = (dateString) => {
  return moment(dateString).format("DD MMM");
};

export const isEasterPeriod = (date) => {
  const currentYear = date.getFullYear();
  // eslint-disable-next-line no-magic-numbers
  const easterStart = new Date(currentYear, 3, 14, 0, 0, 0);
  // eslint-disable-next-line no-magic-numbers
  const easterEnd = new Date(currentYear, 3, 20, 23, 59, 59);
  return date >= easterStart && date <= easterEnd;
};

export const isChristmasPeriod = (date) => {
  const currentYear = date.getFullYear();
  // eslint-disable-next-line no-magic-numbers
  const christmasStart = new Date(currentYear, 10, 13, 0, 0, 0);
  // eslint-disable-next-line no-magic-numbers
  const christmasEnd = new Date(currentYear, 11, 26, 23, 59, 59);
  return date >= christmasStart && date <= christmasEnd;
};

export const isSilvesterPeriod = (date) => {
  const currentYear = date.getFullYear();
  // eslint-disable-next-line no-magic-numbers
  const silvesterStart = new Date(currentYear, 11, 24, 0, 0, 0);
  // eslint-disable-next-line no-magic-numbers
  const silvesterEnd = new Date(currentYear, 11, 30, 23, 59, 59);
  return date >= silvesterStart && date <= silvesterEnd;
};

export const isHolidayPeriod = (date) => {
  return isEasterPeriod(date) || isChristmasPeriod(date) || isSilvesterPeriod(date);
};
